// @core/api/endpoints/tag/create_tag.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTagRequest,
  TagResponse,
} from '../../../types/tag';

const BASE_PATH = '/tag';

/**
 * Create tag
 * Creates a new tag with specified visibility (tenant, team, or personal). Optionally scoped to a specific product.
 */
export async function CreateTag(
  data: CreateTagRequest,
  options?: RequestOptions
): Promise<TagResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tags`;
  const requestOptions = options;
  return client.post<TagResponse>(requestPath, data, requestOptions);
}
